import { render, staticRenderFns } from "./LmProcessTypesNewOrEdit.vue?vue&type=template&id=46b89908&scoped=true"
import script from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmProcessTypesNewOrEdit.vue?vue&type=style&index=0&id=46b89908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b89908",
  null
  
)

export default component.exports